import React from "react";
import { getCategoryLabelById } from "../../../../utils/labelsById";

const ModelViewTextDotValue = ({ data = {} }) => {
  return data !== null ? (
    <div>
      {Object.entries(data).map(([key, entries]) => (
        <div
          key={key}
          style={{
            fontFamily: "Arial, sans-serif",
            fontSize: "14px",
            marginBottom: "50px",
          }}
        >
          <h2 style={{ color: "#e60000", marginBottom: "10px" }}>
            {getCategoryLabelById(key)}
          </h2>
          <div style={{ width: "100%", borderCollapse: "collapse" }}>
            <Section entries={entries} />
          </div>
        </div>
      ))}
    </div>
  ) : null;
};

const OshmaLine = ({ oshma, label, value }) => {
  const formattedValue =
    typeof value === "number"
      ? Number(value).toLocaleString("sq-AL")
      : value ?? "";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        marginBottom: "6px",
        fontFamily: "Arial",
        fontSize: 14,
      }}
    >
      <span style={{ whiteSpace: "nowrap" }}>
        {`Shoqëria "${oshma}" sh.a. - ${label}`}
      </span>
      <span
        aria-hidden
        style={{
          flexGrow: 1,
          height: 1,
          borderBottom: "1px dotted black",
          margin: "0 8px",
          transform: "translateY(-1px)",
        }}
      />
      <span style={{ whiteSpace: "nowrap" }}>{formattedValue}</span>
    </div>
  );
};

const Section = ({ entries }) => (
  <div style={{ marginBottom: "30px" }}>
    {entries.map((entry, index) => {
      const { Oshma, ...rest } = entry;
      return Object.entries(rest).map(([label, value]) => (
        <OshmaLine
          key={`${index}-${label}`}
          oshma={Oshma}
          label={label}
          value={value}
        />
      ));
    })}
  </div>
);

export default ModelViewTextDotValue;
